console.log("✅ MTG Grid JS Loaded");

// ======================================================
// Saved Singles Preferences
// ======================================================

const MTG_ALLOWED_SORTS = [
  "manual",
  "best-selling",
  "title-ascending",
  "price-ascending",
  "price-descending"
];

function getInitialMTGCollectionSort() {
  var select =
    document.querySelector(
      "[data-singles-collection]" +
      "[data-singles-game='magic-card'] " +
      "[data-singles-sort]"
    );

  var candidate =
    select
      ? String(
          select.value || ""
        )
      : "";

  return MTG_ALLOWED_SORTS.indexOf(
    candidate
  ) !== -1
    ? candidate
    : "title-ascending";
}

// ======================================================
// Shared Singles Grid Renderer Adapter
// ======================================================

function renderSharedMTGListCard(
  card,
  selected,
  instance
) {
  var titleParts =
    window.SinglesGrid.finish
      .parseTitle(
        selected.title,
        selected.finish,
        MTG_FINISH_CONFIG
      );

  var detailBits = [];

  if (titleParts.details) {
    detailBits.push(
      titleParts.details
    );
  }

  if (selected.number) {
    detailBits.push(
      "#" + selected.number
    );
  }

  var setHtml =
  window.SinglesGrid.render
    .setContent(
      selected.set_name,
      {
        iconHtml:
          renderMTGSetIcon(
            selected.set_code
          )
      }
    );

  var metadataHtml = "";

  var typeLine =
    buildListTypeLine(
      selected
    );

  if (typeLine) {
    metadataHtml +=
      "<div class='singles-list-type-line mtg-list-type-line'>" +
        escapeHtml(typeLine) +
      "</div>";
  }

  metadataHtml +=
    "<div class='singles-list-properties mtg-list-properties'>";

  if (selected.manacost) {
    metadataHtml +=
      "<span class='singles-list-mana mtg-list-mana'>" +
        renderManaCost(
          selected.manacost
        ) +
      "</span>";
  }

  if (selected.rarity) {
    metadataHtml +=
      "<span class='mtg-list-rarity'>" +
        escapeHtml(
          selected.rarity
        ) +
      "</span>";
  }

  if (
    selected.power ||
    selected.toughness
  ) {
    metadataHtml +=
      "<span class='mtg-list-power-toughness'>" +
        escapeHtml(
          selected.power || "—"
        ) +
        "/" +
        escapeHtml(
          selected.toughness || "—"
        ) +
      "</span>";
  }

  metadataHtml += "</div>";

  return window.SinglesGrid.render.listCard(
    card,
    selected,
    instance,
    {

      title:
        titleParts.name,

      isFoil:
        Boolean(
          titleParts.badge
        ),

      finishBadgeHtml:
      window.SinglesGrid.render
        .finishBadge(
          titleParts.badge,
          {
            mode: "list",
            className:
              "mtg-grid-foil-badge " +
              "mtg-list-finish-badge"
          }
        ),

      titleDetailsHtml:
        escapeHtml(
          detailBits.join(" · ")
        ),

      setHtml:
        setHtml,

      metadataHtml:
        metadataHtml,

      formId:
        "W2nZC4"
    }
  );
}

var MTGSharedRenderer = {
  renderGridCard: function(
    card,
    selected,
    instance
  ) {
    return renderSharedMTGGridCard(
      card,
      selected,
      instance
    );
  },

  renderListCard: function(
    card,
    selected,
    instance
  ) {
    return renderSharedMTGListCard(
      card,
      selected,
      instance
    );
  },

  updateCardVariant: function(
    cardElement,
    card,
    selected,
    instance
  ) {
    if (
      cardElement.matches(
        "[data-singles-list-card]"
      )
    ) {
      window.SinglesGrid.render
        .updateListCardVariant(
          cardElement,
          selected,
          {
            formId:
              "W2nZC4"
          }
        );

      return;
    }

    window.SinglesGrid.render
      .updateGridCardVariant(
        cardElement,
        selected,
        {
          formId:
            "W2nZC4"
        }
      );
      }
    };

// ======================================================
// Shared Singles Grid Instance
// ======================================================

var MTGSinglesGrid = null;

function initializeMTGSinglesGridInstance() {
  if (MTGSinglesGrid) {
    return;
  }

  /*
    Create the shared MTG SinglesGrid instance
    for either a collection page or Search page.
  */
  var collectionRoot =
    document.querySelector(
      "[data-singles-collection]" +
      "[data-singles-game='magic-card']"
    );

  var searchRoot =
    document.querySelector(
      "[data-singles-search-results]" +
      "[data-game='magic']"
    );

  var isSearchPage =
    !collectionRoot &&
    Boolean(searchRoot);

  if (
    !collectionRoot &&
    !searchRoot
  ) {
    return;
  }

  if (
    !window.SinglesGrid ||
    typeof window.SinglesGrid.create !==
      "function"
  ) {
    console.error(
      "Shared SinglesGrid instance API is unavailable."
    );

    return;
  }

  MTGSinglesGrid =
    window.SinglesGrid.create({
      id:
        isSearchPage
          ? "mtg-search"
          : "mtg-collection",
      game: "magic-card",
      storageNamespace: "mtg",

      root:
        isSearchPage
          ? (
              "[data-singles-search-results]" +
              "[data-game='magic']"
            )
          : (
              "[data-singles-collection]" +
              "[data-singles-game='magic-card']"
            ),

      grid:
        "#mtg-card-grid",

      rowsElementId:
        isSearchPage
          ? "singles-search-cardjson"
          : "",  

      renderer:
        MTGSharedRenderer,

      defaultAvailability:
        isSearchPage
          ? "all"
          : "instock",

      persistAvailability:
        false,

      stockFirstWhenAll:
        isSearchPage,

      persistSort:
        !isSearchPage,  

      defaultView:
        "grid",

      defaultSort:
        isSearchPage
          ? "best-selling"
          : getInitialMTGCollectionSort(),  
          
      sortRenderDelay:
        isSearchPage
          ? 50
          : 0,    

      allowedSorts:
        MTG_ALLOWED_SORTS,

      filterDefinitions: [
        {
          key: "finish",
          field: "finish",
          match: "exact",
          selection: "any"
        },

        {
          key: "color",
          field: "colors",
          label: "Mana Color",
          selection: "any",

          getValues: function(card) {
            var foundColors = {};

            card.variants.forEach(
              function(row) {
                String(row.colors || "")
                  .toUpperCase()
                  .split(/[,| ]+/)
                  .filter(Boolean)
                  .forEach(function(color) {
                    if (
                      color === "W" ||
                      color === "U" ||
                      color === "B" ||
                      color === "R" ||
                      color === "G"
                    ) {
                      foundColors[color] = true;
                    }
                  });
              }
            );

            var colors =
              Object.keys(foundColors);

            if (!colors.length) {
              return ["C"];
            }

            if (colors.length > 1) {
              colors.push("M");
            }

            return colors;
          }
        },

        {
          key: "rarity",
          field: "rarity",
          match: "exact",
          selection: "any"
        },

        {
          key: "type",
          field: "types",
          match: "contains",
          selection: "any"
        },

        {
          key: "supertype",
          field: "supertypes",
          match: "contains",
          selection: "any"
        },
        {
          key: "subtype",
          field: "subtypes",
          label: "Subtype",

          match: "exact",
          selection: "all",

          separator: /,\s*/,

          control: "search-multiselect",

          placeholder:
            "Search subtype...",

          emptyText:
            "No matching subtypes",

          initialSuggestions: 8,
          maxSuggestions: 50
        }
      ]
    });

    /*
      MTG Search always begins with All cards
      and Best Selling source order.
    */
    if (isSearchPage) {
      MTGSinglesGrid.state.availability =
        "all";

      MTGSinglesGrid.state.sort =
        "best-selling";
    }

  /*
    Search pages use the shared embedded-row loader.

    Collection pages keep their existing
    collection-navigation loading path.
  */
  if (isSearchPage) {
    MTGSinglesGrid
      .initialize()
      .catch(function(error) {
        console.error(
          "MTG search grid initialization failed:",
          error
        );
      });

    return;
  }

  /*
    MTG collection loading is still handled by
    the shared collection navigator below.
  */
  if (
    !MTGSinglesGrid.resolveElements()
  ) {
    console.error(
      "MTG shared grid elements could not be resolved."
    );

    MTGSinglesGrid = null;

    return;
  }

  MTGSinglesGrid.bindEvents();
  MTGSinglesGrid.syncControls();
}

// ======================================================
// Card Helpers
// ======================================================

function escapeHtml(value) {
  return window.SinglesGrid.helpers
    .escapeHtml(value);
}

function renderManaCost(value) {
  var raw = String(value || "").trim();

  if (!raw) return "";

  var symbols = raw.match(/\{[^}]+\}/g);

  if (!symbols) {
    return escapeHtml(raw);
  }

  return symbols.map(function(symbol) {
    var code = symbol
      .slice(1, -1)
      .trim()
      .toLowerCase()
      .replace(/\//g, "");

    var readable = symbol
      .slice(1, -1)
      .trim();

    return (
      "<i" +
        " class='ms ms-" + escapeHtml(code) + " ms-cost'" +
        " aria-label='" + escapeHtml(readable) + " mana'" +
        " role='img'" +
      "></i>"
    );
  }).join("");
}

function renderMTGSetIcon(
  setCode
) {
  setCode =
    String(
      setCode || ""
    )
      .toLowerCase()
      .trim();

  if (!setCode) {
    return "";
  }

  return (
    "<i" +
      " class=\"ss ss-" +
        escapeHtml(
          setCode
        ) +
      "\"" +
      " aria-hidden=\"true\"" +
    "></i>"
  );
}

// ======================================================
// Finish Badges
// ======================================================

const MTG_FINISH_CONFIG = {
  nonfoilTerms: [
    "nonfoil",
    "non-foil"
  ],

  genericFoilTerms: [
    "foil"
  ],

  genericText:
    "FOIL",

  genericClass:
    "badge-regular",

  genericRemoveText:
    "Foil",

  specialFinishes: [
    { match: "etched", text: "ETCHED", cls: "badge-etched", removeText: "Etched" },  
    { match: "ampersand foil", text: "AMPERSAND FOIL", cls: "badge-ampersand", removeText: "Ampersand Foil" },
    { match: "chocobo track foil", text: "CHOCOBO TRACK FOIL", cls: "badge-chocobo-track", removeText: "Chocobo Track Foil" },
    { match: "confetti foil", text: "CONFETTI FOIL", cls: "badge-confetti", removeText: "Confetti Foil" },
    { match: "cosmic foil", text: "COSMIC FOIL", cls: "badge-cosmic", removeText: "Cosmic Foil" },
    { match: "double rainbow foil", text: "DOUBLE RAINBOW FOIL", cls: "badge-rainbow", removeText: "Double Rainbow Foil" },
    { match: "dragonscale foil", text: "DRAGONSCALE FOIL", cls: "badge-dragonscale", removeText: "Dragonscale Foil" },
    { match: "first place foil", text: "FIRST PLACE FOIL", cls: "badge-first-place", removeText: "First Place Foil" },
    { match: "fracture foil", text: "FRACTURE FOIL", cls: "badge-fracture", removeText: "Fracture Foil" },
    { match: "galaxy foil", text: "GALAXY FOIL", cls: "badge-galaxy", removeText: "Galaxy Foil" },
    { match: "gilded foil", text: "GILDED FOIL", cls: "badge-gilded", removeText: "Gilded Foil" },
    { match: "halo foil", text: "HALO FOIL", cls: "badge-halo", removeText: "Halo Foil" },
    { match: "invisible ink foil",text: "INVISIBLE INK FOIL", cls: "badge-invisible-ink", removeText: "Invisible Ink Foil" },
    { match: "mana foil", text: "MANA FOIL", cls: "badge-mana", removeText: "Mana Foil" },
    { match: "neon ink foil", text: "NEON INK FOIL", cls: "badge-neon-ink", removeText: "Neon Ink Foil" },
    { match: "neon ink blue foil", text: "NEON INK BLUE FOIL", cls: "badge-neon-ink-blue", removeText: "Neon Ink Blue Foil" },
    { match: "neon ink green foil", text: "NEON INK GREEN FOIL", cls: "badge-neon-ink-green", removeText: "Neon Ink Green Foil" },
    { match: "neon ink pink foil", text: "NEON INK PINK FOIL", cls: "badge-neon-ink-pink", removeText: "Neon Ink Pink Foil" },
    { match: "neon ink Purple foil", text: "NEON INK PURPLE FOIL", cls: "badge-neon-ink-purple", removeText: "Neon Ink Purple Foil" },
    { match: "neon ink Red foil", text: "NEON INK RED FOIL", cls: "badge-neon-ink-red", removeText: "Neon Ink Red Foil" },
    { match: "neon ink three color foil", text: "NEON INK FOIL", cls: "badge-neon-ink", removeText: "Neon Ink Three-Color Foil" },
    { match: "neon ink yellow foil", text: "NEON INK YELLOW FOIL", cls: "badge-neon-ink-yellow", removeText: "Neon Ink Yellow Foil" },
    { match: "oil slick raised foil", text: "OIL SLICK RAISED FOIL", cls: "badge-oil-slick", removeText: "Oil Slick Raised Foil" },
    { match: "pool party foil", text: "POOL PARTY FOIL", cls: "badge-pool-party", removeText: "Pool Party Foil" },
    { match: "rainbow foil", text: "RAINBOW FOIL", cls: "badge-rainbow", removeText: "Rainbow Foil" },
    { match: "raised foil", text: "RAISED FOIL", cls: "badge-raised", removeText: "Raised Foil" },
    { match: "ripple foil", text: "RIPPLE FOIL", cls: "badge-ripple", removeText: "Ripple Foil" },
    { match: "silver foil", text: "SILVER FOIL", cls: "badge-silver", removeText: "Silver Foil" },
    { match: "silver screen foil", text: "SILVER SCREEN FOIL", cls: "badge-silver-screen", removeText: "Silver Screen Foil" },
    { match: "silver scroll foil", text: "SILVER SCROLL FOIL", cls: "badge-silver-scroll", removeText: "Silver Scroll Foil" },
    { match: "singularity foil", text: "SINGULARITY FOIL", cls: "badge-singularity", removeText: "Singularity Foil" },
    { match: "step and compleat foil", text: "STEP & COMPLEAT FOIL", cls: "badge-step-and-compleat", removeText: "Step-and-compleat Foil" },
    { match: "surge foil", text: "SURGE FOIL", cls: "badge-surge", removeText: "Surge Foil" },
    { match: "textured foil", text: "TEXTURED FOIL", cls: "badge-textured", removeText: "Textured Foil" },
  ]  
};

function renderSharedMTGGridCard(
  card,
  selected,
  instance
) {
  var titleParts =
  window.SinglesGrid.finish
    .parseTitle(
      selected.title,
      selected.finish,
      MTG_FINISH_CONFIG
    );

  var detailBits = [];

  if (titleParts.details) {
    detailBits.push(
      titleParts.details
    );
  }

  if (selected.number) {
    detailBits.push(
      "#" + selected.number
    );
  }

  var titleExtraHtml =
  window.SinglesGrid.render
    .gridTitleDetails(
      detailBits.join(" · ")
    );

  var finishBadgeHtml =
  window.SinglesGrid.render
    .finishBadge(
      titleParts.badge,
      {
        mode: "grid",
        className:
          "mtg-grid-foil-badge"
      }
    );

  var setRowHtml =
  window.SinglesGrid.render
    .gridSet(
      selected.set_name,
      {
        iconHtml:
          renderMTGSetIcon(
            selected.set_code
          )
      }
    );

  return window.SinglesGrid.render
    .gridCard(
      card,
      selected,
      instance,
      {
        title:
          titleParts.name,

        productUrl:
          selected.product_url,

        imageUrl:
          selected.img_url,

        imageAlt:
          selected.title,

        isFoil:
          Boolean(
            titleParts.badge
          ),

        titleExtraHtml:
          titleExtraHtml,

        finishBadgeHtml:
          finishBadgeHtml,

        setRowHtml:
          setRowHtml,

        formId:
          "W2nZC4"
      }
    );
}

function buildListTypeLine(variant) {
  var supertypes =
    String(variant.supertypes || "").trim();

  var types =
    String(variant.types || "").trim();

  var subtypes =
    String(variant.subtypes || "").trim();

  var mainType = [supertypes, types]
    .filter(Boolean)
    .join(" ");

  if (subtypes) {
    mainType +=
      (mainType ? " — " : "") +
      subtypes;
  }

  return mainType;
}


// ======================================================
// Filters
// ======================================================

    var MTGSharedCollectionNavigation =
      null;

    function initializeMTGSharedCollectionNavigation() {
      if (MTGSharedCollectionNavigation) {
        return;
      }

      if (
        !window.SinglesGrid ||
        typeof window.SinglesGrid
          .createCollectionNavigation !==
          "function"
      ) {
        console.error(
          "Shared collection navigation is unavailable."
        );

        return;
      }

      MTGSharedCollectionNavigation =
        window.SinglesGrid
          .createCollectionNavigation(
            {
              root:
                "[data-singles-collection]" +
                "[data-singles-game='magic-card']",

              rootSelector:
                "[data-singles-collection]" +
                "[data-singles-game='magic-card']",

              gridInstance:
                MTGSinglesGrid,

              loaderOptions: {
                pageSize: 50,
                maximumPages: 5000,
                maxConcurrentRequests: 5,
                requestRetries: 2,
                retryDelay: 400,
                requestTimeout: 30000
              },
            }
          );

      if (!MTGSharedCollectionNavigation) {
        return;
      }

      MTGSharedCollectionNavigation
        .loadCurrent()
        .catch(function(error) {
          console.error(
            "Initial MTG collection load failed:",
            error
          );
        });
    }

// ======================================================
// Grid / List View
// ======================================================

document.addEventListener(
  "DOMContentLoaded",
  function() {
    var isCollectionPage =
      Boolean(
        document.querySelector(
          "[data-singles-collection]" +
          "[data-singles-game='magic-card']"
        )
      );

    /*
      Create the shared instance first.

      If successful, it owns all migrated
      standard controls.
    */
    initializeMTGSinglesGridInstance();

    /*
      Sort state belongs to SinglesGrid, but MTG
      still needs its collection-reload bridge
      for Shopify server ordering.
    */
    if (isCollectionPage) {
      initializeMTGSharedCollectionNavigation();
    }
  }
);
